import AOS from "aos";

document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".js-filter-item").forEach((element) => {
    element.addEventListener("click", () => {
      document.querySelectorAll(".js-filter-item").forEach((no) => {
        no.classList.remove("selected");
      });
      element.classList.add("selected");
      AOS.refresh();
      AOS.refreshHard();
    });
  });

  document.querySelectorAll(".js-filter-item").forEach((element) => {
    if (element.getAttribute("data-filter") === "active") {
      element.addEventListener("click", () => {
        document.querySelectorAll(".all").forEach((item) => {
          item.classList.remove("show-logo");
          item.style.display = "none";
        });
        document.querySelectorAll("[data-category]").forEach((item) => {
          if (item.dataset["category"] === "active,all,") {
            item.classList.add("show-logo");
            item.style.display = "block";
          }
        });
        AOS.refresh();
        AOS.refreshHard();
      });
    } else if (element.getAttribute("data-filter") === "exit") {
      element.addEventListener("click", () => {
        document.querySelectorAll("[data-category]").forEach((item) => {
          item.classList.remove("show-logo");
          item.style.display = "none";
        });
        document.querySelectorAll("[data-category]").forEach((item) => {
          if (item.dataset["category"] === "all,exit,") {
            item.classList.add("show-logo");
            item.style.display = "block";
          }
        });
        AOS.refresh();
        AOS.refreshHard();
      });
    } else if (element.getAttribute("data-filter") === "all") {
      element.addEventListener("click", () => {
        document.querySelectorAll("[data-category]").forEach((item) => {
          item.classList.remove("show-logo");
          item.style.display = "none";
        });
        document.querySelectorAll(".all").forEach((item) => {
          item.classList.add("show-logo");
          item.style.display = "block";
        });
        AOS.refresh();
        AOS.refreshHard();
      });
    }
  });

  AOS.refresh();
  AOS.refreshHard();
});
